import { render, staticRenderFns } from "./newUpLoadImgOne.vue?vue&type=template&id=0566b6eb&scoped=true&"
import script from "./newUpLoadImgOne.vue?vue&type=script&lang=js&"
export * from "./newUpLoadImgOne.vue?vue&type=script&lang=js&"
import style0 from "./newUpLoadImgOne.vue?vue&type=style&index=0&id=0566b6eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0566b6eb",
  null
  
)

export default component.exports